import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Container } from "@mui/material";

import Navbar from "./components/Navbar.component";
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";
import BookPage from "./pages/BookPage";

import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import AccountDeletionPage from "./pages/AccountDeletionPage.jsx";
import ContentPolicyPage from "./pages/ContentPolicyPage";
import SubscriptionPolicyPage from "./pages/SubscriptionPolicyPage";

import Footer from "./components/Footer.component";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Container sx={{ marginTop: "5rem" }}>
        <Routes>
          <Route path="/" exact element={<HomePage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/library/:bookId" element={<BookPage />} />

          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/account-deletion" element={<AccountDeletionPage />} />
          <Route path="/content-policy" element={<ContentPolicyPage />} />
          <Route path="/subscription-policy" element={<SubscriptionPolicyPage />} />
        </Routes>
      </Container>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
